import { courseForWho } from '../../../mocks/courseModules';

export default function ForWhoSection() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <span className="inline-flex items-center gap-2 px-4 py-2 bg-amber-50 text-amber-600 text-sm font-semibold rounded-full mb-4">
              <i className="ri-user-heart-line w-4 h-4 flex items-center justify-center"></i>
              Para Quem é Este Curso
            </span>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Feito para educadores que querem{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-amber-500">
                evoluir
              </span>
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-10">
              Não importa se você nunca usou IA antes. O curso foi desenhado para professores de todos os níveis, com linguagem simples e exemplos práticos do dia a dia escolar.
            </p>

            <div className="space-y-6">
              {courseForWho.map((item, index) => (
                <div key={index} className="flex items-start gap-4 group">
                  <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-orange-500 to-amber-500 flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                    <i className={`${item.icon} text-white text-xl`}></i>
                  </div>
                  <div>
                    <h3 className="text-base font-bold text-gray-900 mb-1">{item.title}</h3>
                    <p className="text-sm text-gray-600 leading-relaxed">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <img
              src="https://public.readdy.ai/ai/img_res/b10bcac7821f03e411a8c82e117fffcb.jpg"
              alt="Professores colaborando com tecnologia"
              className="rounded-3xl shadow-2xl w-full h-[520px] object-cover object-top"
            />
            <div className="absolute -bottom-6 right-6 bg-white rounded-2xl shadow-xl p-5 max-w-xs">
              <div className="flex items-center gap-2 mb-2">
                <i className="ri-double-quotes-l text-orange-400 text-2xl w-6 h-6 flex items-center justify-center"></i>
              </div>
              <p className="text-sm text-gray-700 italic leading-relaxed">
                &ldquo;Nunca imaginei que seria tão fácil usar IA nas minhas aulas. O curso mudou minha forma de ensinar!&rdquo;
              </p>
              <p className="text-xs text-gray-500 mt-2 font-semibold">— Profa. Mariana, Ensino Fundamental</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
